/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Lists_AvailableInputs */

const en_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lists available.`)
};

const fr_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune liste disponible.`)
};

const de_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine Listen verfügbar.`)
};

const it_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun elenco disponibile.`)
};

const ru_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Списки отсутствуют.`)
};

const es_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay listas disponibles`)
};

const zh_cn2_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无列表。`)
};

const ja_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なリストはありません。`)
};

const hi_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई सूची उपलब्ध नहीं है।`)
};

const pt_pt2_no_lists_available = /** @type {(inputs: No_Lists_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma lista disponível.`)
};

/**
* | output |
* | --- |
* | "No lists available." |
*
* @param {No_Lists_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_lists_available = /** @type {((inputs?: No_Lists_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Lists_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_lists_available(inputs)
	if (locale === "de") return de_no_lists_available(inputs)
	if (locale === "it") return it_no_lists_available(inputs)
	if (locale === "ru") return ru_no_lists_available(inputs)
	if (locale === "es") return es_no_lists_available(inputs)
	if (locale === "zh-CN") return zh_cn2_no_lists_available(inputs)
	if (locale === "ja") return ja_no_lists_available(inputs)
	if (locale === "hi") return hi_no_lists_available(inputs)
	if (locale === "pt-PT") return pt_pt2_no_lists_available(inputs)
	return en_no_lists_available(inputs)
});